export function phone(){
    const phoneInput = document.querySelector('.input-phone') as HTMLInputElement | null;

    if (phoneInput) {
        // Базовый шаблон маски
        const maskTemplate = '+7 ___ ___-__-__';

        phoneInput.addEventListener('input', () => {
            const onlyDigits = phoneInput.value.replace(/\D/g, ''); // Оставляем только цифры
            let result = '+7 ';

            // Убираем ведущую 7/8 если пользователь начал с них
            const digits = onlyDigits.startsWith('7') ? onlyDigits.slice(1) :
                onlyDigits.startsWith('8') ? onlyDigits.slice(1) : onlyDigits;

            if (digits.length > 0) result += digits.substring(0, 3);
            if (digits.length >= 4) result += ' ' + digits.substring(3, 6);
            if (digits.length >= 7) result += '-' + digits.substring(6, 8);
            if (digits.length >= 9) result += '-' + digits.substring(8, 10);

            phoneInput.value = result;
        });

        phoneInput.addEventListener('keydown', e => {
            // Разрешаем только цифры, Backspace, Delete, стрелки и Tab
            if (
                !/[0-9]/.test(e.key) &&
                !['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'].includes(e.key)
            ) {
                e.preventDefault();
            }
        });

        // При фокусе — если поле пустое, подставляем префикс +7
        phoneInput.addEventListener('focus', () => {
            if (phoneInput.value.trim() === '') {
                phoneInput.value = '+7 ';
            }
        });

        // При потере фокуса — если остался только "+7", очищаем
        phoneInput.addEventListener('blur', () => {
            if (phoneInput.value === '+7 ' || phoneInput.value === '+7') {
                phoneInput.value = '';
            }
        });
    }

}